import type {
  CopilotChatOrg,
  CopilotChatPayload,
  CopilotChatRepo,
  Icebreakers as ImportedIcebreakers,
} from '@github-ui/copilot-chat-types'
/* eslint-disable-next-line @github-ui/github-monorepo/no-use-app-payload --
   useAppPayload is deprecated. See
   https://thehub.github.com/epd/engineering/dev-practicals/frontend/react/data-router/migration/app-payload-deprecation/ */
import {useAppPayload} from '@github-ui/react-core/use-app-payload'
import {MarkGithubIcon} from '@primer/octicons-react'
import {Button, Link} from '@primer/react'

import type {CopilotImmersiveLoggedOutPayload} from '../copilot-immersive-logged-out-types'
import styles from './CopilotHeader.module.css'

export interface CopilotImmersivePayload extends CopilotChatPayload {
  copilotChatSettingEnabled: boolean
  searchWorkerFilePath: string
  requestedTopic?: CopilotChatRepo
  ssoOrganizations: CopilotChatOrg[]
  copilotUpsellBannerDismissed: boolean
  icebreakers: ImportedIcebreakers
  graphqlApiUrl: string
  previewUrl: string
  canShareThread: boolean
  realIp?: string
  helpUrl?: string
  figmaAuthUrl?: string
}

export const CopilotHeader: React.FC = () => {
  const {signInPath, signUpPath} = useAppPayload<CopilotImmersiveLoggedOutPayload>() || {}

  return (
    <header className={styles.AppHeader}>
      <Link aria-label="Homepage" href="/">
        <MarkGithubIcon className={styles.AppHeaderLogo} />
      </Link>
      <span className={styles.AppHeaderTitle}>Copilot</span>

      <div className={styles.buttonContainer}>
        <Button as="a" href={signInPath} variant="default">
          Sign in
        </Button>
        <Button as="a" href={signUpPath} variant="primary">
          Sign up
        </Button>
      </div>
    </header>
  )
}
